import { IIconProps } from '~/types';

const AddIcon = (props: IIconProps) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m.703-12.375a.703.703 0 1 0-1.406 0v2.672H9.125a.703.703 0 1 0 0 1.406h2.672v2.672a.703.703 0 0 0 1.406 0v-2.672h2.672a.703.703 0 0 0 0-1.406h-2.672z"
      fill="#2B2D54"
    />
  </svg>
);
export default AddIcon;
